import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./auth/auth.slice";
import toggleSlice from "./toggle/toggle.slice";
import categorySlice from "./category/category.slice";
import productSlice from "./products/product.slice";
import unitSlice from "./units/unit.slice";
import brandSlice from "./brand/brand.slice";
import activitySlice from "./activity/activity.slice";
import saleSlice from "./sales/sale.slice";
import customerSlice from "./customers/customer.slice";
import supplierSlice from "./suppliers/supplier.slice";
import stockSlice from "./stock/stock.slice";
import analyticSlice from "./analytics/analytic.slice";
import shopSlice from "./shops/shop.slice";
import businessSlice from "./business/business.slice";
import usersSlice from "./users/users.slice";
import rolesSlice from "./roles/roles.slice";
import expensesSlice from "./expenses/expenses.slice";
import purchasesSlice from "./purchases/purchase.slice";
import surplusSalesSlice from "./surplusSales/surplusSales.slice";
import transferSlice from "./transfers/transfer.slice";
import chatSlice from "./chat/chat.slice";
import taxRateSlice from "./taxRates/taxRate.slice";
import sandboxSlice from "./sandbox/sandbox.slice";

export const makeStore = () => {
  return configureStore({
    reducer: {
      auth: authSlice,
      toggle: toggleSlice,
      category: categorySlice,
      product: productSlice,
      unit: unitSlice,
      brand: brandSlice,
      activity: activitySlice,
      sales: saleSlice,
      customer: customerSlice,
      supplier: supplierSlice,
      stock: stockSlice,
      analytic: analyticSlice,
      shop: shopSlice,
      business: businessSlice,
      users: usersSlice,
      roles: rolesSlice,
      expenses: expensesSlice,
      purchases: purchasesSlice,
      surplusSales: surplusSalesSlice,
      transfers: transferSlice,
      chat: chatSlice,
      taxRate: taxRateSlice,
      sandbox: sandboxSlice,
    },
    devTools: true,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
        immutableCheck: false,
      }),
  });
};

